import React, { useEffect, useRef } from 'react';
import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.mjs`;

const PdfPreview = ({ pdf, compiling }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!pdf) return;
    let cancelled = false;
    (async () => {
      const doc = await pdfjsLib.getDocument({ data: pdf.slice(0) }).promise;
      if (cancelled) return;
      const container = containerRef.current;
      if (!container) return;
      container.innerHTML = '';
      for (let n = 1; n <= doc.numPages; n++) {
        const page = await doc.getPage(n);
        // Render at 2x for crisp text, then display responsively (CSS scales down).
        const viewport = page.getViewport({ scale: 2 });
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        canvas.className = 'block w-full max-w-[816px] h-auto mx-auto mb-5 last:mb-0 rounded-md bg-white shadow-2xl shadow-black/50 ring-1 ring-black/10';
        container.appendChild(canvas);
        await page.render({ canvasContext: ctx, viewport }).promise;
      }
    })();
    return () => { cancelled = true; };
  }, [pdf]);

  return (
    <div className="relative w-full">
      {compiling && (
        <div className="absolute top-2 left-1/2 -translate-x-1/2 z-10">
          <span className="inline-flex items-center gap-2 bg-neutral-900/90 text-neutral-200 text-xs px-3 py-1.5 rounded-full border border-white/10 shadow-lg">
            <span className="h-1.5 w-1.5 rounded-full bg-amber-400 animate-pulse" /> Recompiling…
          </span>
        </div>
      )}
      {!pdf && (
        <div className="flex flex-col items-center justify-center py-24 text-neutral-500">
          <div className="h-8 w-8 rounded-full border-2 border-neutral-700 border-t-cyan-400 animate-spin mb-4" />
          <p className="text-sm">Building your resume preview…</p>
          <p className="text-xs text-neutral-600 mt-1">First render loads the typesetting engine (one-time).</p>
        </div>
      )}
      <div ref={containerRef} />
    </div>
  );
};

export default PdfPreview;
